import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'
import { useAppSelector } from '../../store/hooks'
import { selectBrandTheme } from '../../store/reducer/ui'

export const themeCarrier = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#152e70',
        },
    },
})

export const themeCiat = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#e40e12',
        },
    },
})

export const themeViessmann = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#7d7d7d',
        },
    },
})

type Props = {
    children: JSX.Element | JSX.Element[]
}

export const MuiProvider = ({ children }: Props) => {
    const company = useAppSelector((state) => selectBrandTheme(state.ui))

    const getTheme = () => {
        switch (company) {
            case 'ciat':
                return themeCiat
            case 'viessmann':
                return themeViessmann
            case 'carrier':
            default:
                return themeCarrier
        }
    }

    const theme = getTheme()

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    )
}
